import { connect } from 'react-redux';
import SubCategories from 'landing_pages/components/sub_categories';

const mapStateToProps = ({ categories }) => {
  const subcats = categories.data.reduce((acc, cat) => ([
    ...acc,
    ...cat.sub_categories.map(subcat => ({ ...subcat, category: cat }))
  ]), []);

  return {
    subcats
  };
}

export default connect(mapStateToProps)(SubCategories);



// WEBPACK FOOTER //
// ./landing_pages/containers/sub_categories.js